/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('contactedit', {
      restrict: 'E',
      bindings: {
        contactdata: '=',
        parentsave: '&',
        showrelation: '<?'
      },
      templateUrl: 'vcclient/contactedit-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.formatphone = formatphone;
          vm.childsave = childsave;
          vm.zipsave = zipsave;
          
          
          vm.$onInit = function () {
            // $log.debug('***** debug: contactdata: ', vm.contactdata);
            if (angular.isUndefined(vm.contactdata.country)) {vm.contactdata.country = 'Österreich'}
            vm.lastcontact = angular.copy(vm.contactdata);
          };

          vm.$onChange = function (change) {
            $log.debug('***** debug: cahnge contactdata: ', vm.contactdata);
            if (angular.isUndefined(vm.contactdata.country)) {vm.contactdata.country = 'Österreich'}
            vm.lastcontact = angular.copy(vm.contactdata);
          };

          function childsave(key, value) {
            vm.contactdata[key] = value;
            vm.save();
          }
  
          function zipsave (zip, city) {
            $log.debug('debug: contactedit zipsave called: ', zip, city);
            vm.contactdata.postcode = zip;
            vm.contactdata.city = city;
            vm.save();
          }
          
          function formatphone(num) {
            // TODO: phonenumber formatter
            save();
          }
          
          function save() {
            $log.debug('debug: contactedit save called');
            if (!angular.equals(vm.contactdata, vm.lastcontact)) {
              vm.lastcontact = angular.copy(vm.contactdata);
              $log.debug('debug: contactedit calling parentsave');
              vm.parentsave();
            }
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());